// Match (?live=1; teams and matches, Ben 2026-10-30: "why would a match result be called a bio?" —
// its own module, not a third card on the Bio). Shows the match dropped on it (`_match`,
// live/match.ts): a result's score from Match Results, a game's bar from a team's Matches. Added
// without one (its side panel tile, "All") it opens on the current player's latest game (Ben,
// 2026-10-30: "the last match the current live player played in … Arsenal's most recent
// fixture"); a player or a team dropped on it shows theirs (`_matchFor`). Once found the game is
// kept: a later player change doesn't swap it.

import { useEffect } from "react";
import { setModState, type ProtoModuleProps } from "./bridge.js";
import { ModuleExplainer } from "./ModuleExplainer.js";
import { explainMatch } from "./explain.js";
import { MatchCard } from "./MatchCard.js";
import { MatchSearch } from "./MatchSearch.js";
import { loadLatestMatch, loadLatestTeamMatch, matchForOfModule, matchOfModule, type MatchFor, type MatchRef } from "../live/match.js";
import { liveApi } from "../live/api.js";
import { useLiveQuery } from "../live/query.js";
import { getStickyPlayer } from "../canvas/sticky-player.js";

const EMPTY = "Drag a game here (a result's score from Match Results, a game's bar from a team's Matches), or a player or a team for their latest game.";

export function MatchModule({ mod, body }: ProtoModuleProps) {
  const match = matchOfModule(mod);
  const sticky = getStickyPlayer();
  const source: MatchFor | null = matchForOfModule(mod) ?? (sticky === null ? null : { player: sticky });
  useEffect(() => {
    body.style.justifyContent = "flex-start";
  }, [body]);
  // The search box sits above whatever the module shows (Ben, 2026-10-30).
  return (
    <>
      <MatchSearch mod={mod} body={body} />
      {match ? <MatchView mod={mod} match={match} /> : source === null ? <div className="stats-empty">{EMPTY}</div> : <LatestMatch mod={mod} source={source} />}
    </>
  );
}

/** A player's or a team's latest game, kept on the module once found (Undo, dashboards). */
function LatestMatch({ mod, source }: { mod: HTMLElement; source: MatchFor }) {
  const key = "player" in source ? `match:latest:${source.player}` : `match:latest:team:${source.team.id}:${source.team.competitionId}:${source.team.season ?? "newest"}`;
  const latest = useLiveQuery(key, () => ("player" in source ? loadLatestMatch(liveApi(), source.player) : loadLatestTeamMatch(liveApi(), source.team)));
  useEffect(() => {
    if (!latest) return;
    setModState(mod, "_match", latest);
    setModState(mod, "_matchFor", undefined);
  }, [mod, latest]);
  if (!latest) return <div className="stats-empty">{EMPTY}</div>;
  return <MatchView mod={mod} match={latest} />;
}

function MatchView({ mod, match }: { mod: HTMLElement; match: MatchRef }) {
  return (
    <div className="bio-wrap">
      <ModuleExplainer mod={mod} paragraphs={explainMatch(match.home.name, match.away.name)} />
      <MatchCard match={match} mod={mod} />
    </div>
  );
}
